import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-progress-ring',
    template: `
        <svg [attr.width]="radius * 2" [attr.height]="radius * 2">
            <circle
                [class]="!backgroundColor ? 'stroke-primary-500' : ''"
                [attr.stroke]="backgroundColor || null"
                [attr.stroke-width]="strokeWidth"
                fill="transparent"
                [attr.r]="radius - strokeWidth / 2"
                [attr.cx]="radius"
                [attr.cy]="radius"
                [style.opacity]="backgroundColor ? 1 : 0.3"
            />
            <circle
                [class]="!color ? 'stroke-primary-500' : ''"
                [attr.stroke]="color || null"
                [attr.stroke-width]="strokeWidth"
                stroke-linecap="round"
                fill="transparent"
                [attr.r]="radius - strokeWidth / 2"
                [attr.cx]="radius"
                [attr.cy]="radius"
                [style.stroke-dasharray]="circumference + ' ' + circumference"
                [style.stroke-dashoffset]="
                    circumference *
                    (1 - (value > 1 ? 1 : value < 0 ? 0 : value))
                "
                [attr.transform]="'rotate(-90,' + radius + ',' + radius + ')'"
            />
            <text
                [attr.font-size]="textSize + 'px'"
                [attr.text-anchor]="'middle'"
                dominant-baseline="central"
                [attr.x]="radius"
                [attr.y]="radius"
                [attr.fill]="textColor || null"
                class="font-bold"
            >
                {{ this.value * 100 | round }}%
            </text>
        </svg>
    `,
    styles: [':host {display: inline-block}'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ProgressRingComponent {
    @Input() public value = 0.25;
    @Input() public radius = 25;
    @Input() public strokeWidth = 1;
    @Input() public textSize = 16;
    @Input() public color?: string; // Optional color input
    @Input() public backgroundColor?: string; // Optional background circle color
    @Input() public textColor?: string; // Optional text color input

    public get circumference(): number {
        return 2 * Math.PI * (this.radius - this.strokeWidth / 2);
    }
}
